'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Drawers = function () {
  function Drawers(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Drawers);

    this.els = {
      el: el,
      body: document.body,
      backdrop: (0, _functional.getElement)('.drw-Drawer_Backdrop', { context: el })
    };
    this.matches = {
      trigger: '[data-module-drawers-trigger]',
      close: '[data-module-drawers-close]',
      backdrop: '.drw-Drawer_Backdrop'
    };
    this.classes = {
      activeClass: 'drw-Drawers-active',
      activeDrawerClass: 'drw-Drawer-active',
      activeTrigger: 'js-Drawers-triggerActive',
      activeBody: 'js-Drawers-active',
      siteOverflowed: 'util-SiteOverflowed'
    };
    this._activeDrawerKey = '';
    this.foundDrawers = (0, _functional.getElements)(this.matches.trigger).reduce(function (acc, el) {
      var key = el.dataset.moduleDrawersTrigger;
      acc[key] = _this.buildDrawer(key, el);

      return acc;
    }, {});

    this.setupListeners();

    window.drawers = this;
  }

  (0, _createClass3.default)(Drawers, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      this.els.body.addEventListener('click', function (e) {
        var target = e.target;


        if (target.closest(_this2.matches.trigger) === false && target.closest(_this2.matches.close) === false && target.closest(_this2.matches.backdrop) === false) {
          return;
        }

        if (target.closest(_this2.matches.trigger)) {
          e.preventDefault();
          var matches = target.closest(_this2.matches.trigger);
          var key = matches.dataset.moduleDrawersTrigger;

          if (key in _this2.foundDrawers === false || key in _this2.foundDrawers && _this2.drawerIsComplete(key) === false) {
            _this2.foundDrawers[key] = _this2.buildDrawer(key, matches);
          }

          var foundDrawer = _this2.foundDrawers[key];
          foundDrawer.trigger.classList.toggle(_this2.classes.activeTrigger, _this2.activeDrawerKey !== key && _this2.foundDrawers[key].isToggle);

          if (foundDrawer.isToggle && _this2.activeDrawerKey === key) {
            _this2.activeDrawerKey = '';

            return;
          }

          _this2.activeDrawerKey = key;
        }

        if (target.closest(_this2.matches.close)) {
          _this2.activeDrawerKey = '';
        }

        if (target.closest(_this2.matches.backdrop)) {
          _this2.activeDrawerKey = '';
        }
      });
    }
  }, {
    key: 'buildDrawer',
    value: function buildDrawer(key, matches) {
      return {
        trigger: matches,
        drawer: (0, _functional.getElement)('[data-module-drawers-drawer="' + key + '"]'),
        close: (0, _functional.getElement)('[data-module-drawers-close="' + key + '"]'),
        isToggle: matches.hasAttribute('data-module-drawers-trigger-toggle')
      };
    }
  }, {
    key: 'drawerIsComplete',
    value: function drawerIsComplete(key) {
      return Object.values(this.foundDrawers[key]).filter(function (val) {
        return val != null;
      }).length === 0;
    }
  }, {
    key: 'activeDrawerKey',
    get: function get() {
      return this._activeDrawerKey;
    },
    set: function set(val) {
      var _this3 = this;

      this._activeDrawerKey = val;

      this.els.body.classList.toggle(this.classes.siteOverflowed, val !== '');
      this.els.body.classList.toggle(this.classes.activeBody, val !== '');
      this.els.el.classList.toggle(this.classes.activeClass, val !== '');

      Object.entries(this.foundDrawers).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        value.drawer.classList.toggle(_this3.classes.activeDrawerClass, key === val);

        if (value.isToggle && key !== val) {
          value.trigger.classList.remove(_this3.classes.activeTrigger);
        }
      });
    }
  }]);
  return Drawers;
}();

exports.default = Drawers;